import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Scheduling|Schedule an Exam|Kryterion';

export type SSOEgressKryterion =
	| 'CPSSOEgressKryterionButton'
	| 'CPSSOEgressKryterionTabTitle'
	| 'CPSSOEgressKryterionPageTitle'
	| 'CPSSOEgressKryterionPageDescription';

export const ssoEgressKryterionLocs: LocDefs<SSOEgressKryterion> = {
	CPSSOEgressKryterionButton: {
		defaultValue: 'SSO to Kryterion',
		description: 'Button to SSO to Kryterion.',
		displayPath: `${dpRoot}|SSO Button`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessIntegrationEgressKryterionScheduling,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressKryterionTabTitle: {
		defaultValue: 'Schedule an Exam',
		description: 'Tab title of Kryterion SSO page.',
		displayPath: `${dpRoot}|Tab Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressKryterionScheduling,
		portal: 'CP',
		htmlAllowed: false,
		legacyName: 'CandidateAccess.Integration.Egress.Kryterion/Scheduling.Exam.Title.TabTitle',
	},
	CPSSOEgressKryterionPageTitle: {
		defaultValue: 'Kryterion SSO',
		description: 'Title of Kryterion SSO page.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressKryterionScheduling,
		portal: 'CP',
		htmlAllowed: false,
		legacyName: 'CandidateAccess.Integration.Egress.Kryterion/Scheduling.Exam.Title.PageTitle',
	},
	CPSSOEgressKryterionPageDescription: {
		defaultValue: '',
		description: 'Title of Kryterion SSO page.',
		displayPath: `${dpRoot}|Page Description`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressKryterionScheduling,
		portal: 'CP',
		htmlAllowed: true,
		legacyName:
			'CandidateAccess.Integration.Egress.Kryterion/Scheduling.Exam.Content.PageDescription',
	},
};

export const LOC_KEYS = MapLocKeys<SSOEgressKryterion>(ssoEgressKryterionLocs);
